import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import AnimatedCard from "../../../../components/AnimatedCard/AnimatedCard";
import AuthMethods from "../../../../components/AuthMethods/AuthMethods";
import { withTranslations } from "../../../../hoc/withTranslations/withTranslations";

const LOCALE = "modules_Registration_pages_SignIn_SignIn";

const SignIn: React.FC = () => {
  const { t } = useTranslation(LOCALE);

  return (
    <div className="flex justify-center flex-col items-center min-h-[calc(100vh-6rem)] bg-background py-8">
      <AnimatedCard title={t("title")} className="bg-white max-w-lg w-full">
        <AuthMethods mode="signin" />
        <div className="text-center mt-4">
          {t("no-account")}{" "}
          <Link to="/registration/signup" className="text-blue-600">
            {t("signup-link")}
          </Link>
        </div>
      </AnimatedCard>
    </div>
  );
};

export default withTranslations(LOCALE)(SignIn);
